// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2-DcQ","info":"Note_info__5mrMq","note":"Note_note__1PB_t","actions":"Note_actions__1O2-t"};